import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import SEO from '../components/SEO';
import { Button } from '../components/ui/button';
import { Home } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-lime-50" data-testid="not-found-page">
      <SEO title="Pagina nu a fost gasita (404)" canonical="/404" />
      <Navbar />
      <div className="pt-32 pb-20 px-4 text-center">
        <h1 className="text-8xl font-bold text-slate-300 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>404</h1>
        <h2 className="text-2xl font-bold text-slate-700 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Pagina nu a fost gasita
        </h2>
        <p className="text-slate-500 mb-8 max-w-md mx-auto">
          Ne pare rau, pagina pe care o cautati nu exista sau a fost mutata.
        </p>
        <Link to="/">
          <Button className="btn-primary px-8 py-3 rounded-full" data-testid="go-home-btn">
            <Home className="w-4 h-4 mr-2" /> Inapoi la pagina principala
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
